import { gql } from '@apollo/client';

const DeleteUserMutation = gql`
    mutation DeleteUser {
        deleteUser {
            message
            success
        }
    }
`;

export { DeleteUserMutation };
